<template>
  <div class="my">
    <img
      src="../../assets/logotable.png"
      style="
        position: fixed;
        top: 0.8rem;
        z-index: 9;
        height: 1.5rem;
        right: 50vw;
      "
    />
    <nav-bar
      title="集团活动"
      left-text="返回"
      right-text="添加活动"
      left-arrow
      @click-left="onClickLeft"
      @click-right="add"
      class="my-nav"
    >
    </nav-bar>
    <div style="margin-top: 2.9rem; background-color: #f7f8fa"></div>
    <!-- 上滑进入 -->
    <cell-group title="活动列表">
      <collapse v-model="activeNames">
        <div v-for="(v, i) in list" :key="i">
          <swipe-cell>
            <collapse-item :title="v.activityName" :name="i">
              <ant-row>
                <ant-col span="9">
                  <div>活动类型:</div>
                  <div>人数上限:</div>
                  <div>预算金额:</div>
                  <div>报名截止时间:</div>
                  <div>活动开始时间:</div>
                  <div>活动结束时间:</div>
                  <div>活动状态:</div>
                  <div>预算执行:</div>
                  <div>报销状态:</div>
                </ant-col>
                <ant-col span="14">
                  <div>{{ v.motionGroup }}</div>
                  <div>{{ v.numberPeople }}</div>
                  <div>{{ v.budget }}元</div>
                  <div>{{ v.activityFinishTime | ptime }}</div>
                  <div>{{ v.activityStartTime | ptime }}</div>
                  <div>{{ v.activityEndTime | ptime }}</div>
                  <div>{{ v.approveStatus | pstatus }}</div>
                  <div>{{ v.actualCost }}元</div>
                  <div>{{ v.budgetResult | pbstatus }}</div>
                </ant-col>
              </ant-row>
              活动内容
              <ant-row style="margin: 10px 0">
                <div class="grey-box" style="min-height: auto">
                  <div class="ql-container ql-snow" style="border: none">
                    <div
                      class="ql-editor"
                      data-gramm="false"
                      contenteditable="false"
                      v-html="v.activityContent"
                    ></div>
                  </div>
                </div>
              </ant-row>
              <grid :column-num="3">
                <grid-item
                  icon="completed"
                  text="提交审批"
                  :class="
                    v.approveStatus == 1 ||
                    v.approveStatus == 2 ||
                    submitApprovalShow
                      ? ''
                      : 'my-btn'
                  "
                  @click="
                    forExamination(
                      v,
                      v.approveStatus == 1 ||
                        v.approveStatus == 2 ||
                        submitApprovalShow
                    )
                  "
                />
                <grid-item
                  icon="cluster"
                  text="分享链接"
                  @click="shareLink(v)"
                  class="my-btn"
                />
                <grid-item
                  icon="friends-o"
                  text="报名人员"
                  @click="applicants(v)"
                  class="my-btn"
                />
                <grid-item
                  icon="photo-o"
                  text="活动图片"
                  @click="updateImg(v)"
                  class="my-btn"
                />
                <!-- 0未审批 1审批中 2通过 3未通过 -->
                <grid-item
                  icon="gold-coin-o"
                  :class="
                    v.approveStatus == 0 ||
                    v.approveStatus == 1 ||
                    v.approveStatus == 3 ||
						v.budget <= 0
                      ? ''
                      : 'my-btn'
                  "
                  text="经费报销"
                  @click="
                    fundApplication(
                      v,
                      v.approveStatus == 0 ||
                        v.approveStatus == 1 ||
                        v.approveStatus == 3 ||
						v.budget <= 0
                    )
                  "
                />
                <grid-item
                  icon="replay"
                  text="重新发起"
                  class="my-btn"
                  @click="reinitiate(v)"
                />
              </grid>
            </collapse-item>
            <template slot="right">
              <ant-button
                square
                type="primary"
                text="修改"
                @click="modify(v)"
              />
              <ant-button square type="danger" text="删除" @click="del(v)" />
            </template>
          </swipe-cell>
        </div>
      </collapse>
      <!-- 分页-->
      <pagination
        v-model="page"
        :total-items="total"
        mode="simple"
        @change="init()"
        v-if="list.length"
      />
      <empty v-else description="暂无数据" />
    </cell-group>
    <!-- 编辑-->
    <popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '90%' }"
      @close="closeMod"
    >
      <div style="margin: 1rem">
        <ant-form
          validate-first
          @submit="onSubmit"
          v-show="!showDate && !showType"
        >
          <ant-field
            label="活动名称："
            v-model="form.activityName"
            required
            rows="2"
            autosize
            type="textarea"
            maxlength="30"
            show-word-limit
            :rules="[{ required: true, message: '请填写活动名称' }]"
            placeholder="请输入内容"
          />
          <ant-field
            v-model="form.motionGroup"
            readonly
            :rules="[{ required: true, message: '请填写活动类型' }]"
            required
            @click="setMotionGroup()"
            label="活动类型"
          />
          <ant-field
            v-model="form.numberPeople"
            required
            type="digit"
            label="人数上限"
          />
          <ant-field
            v-model="form.budget"
            required
            type="number"
            label="预算金额"
          />
          <ant-field
            v-model="form.activityFinishTimeShow"
            readonly
            :rules="[{ required: true, message: '请填写报名截止时间' }]"
            required
            @click="openStartTime(2)"
            label="报名截止时间"
          />
          <ant-field
            v-model="form.activityStartTimeShow"
            readonly
            :rules="[{ required: true, message: '请填写开始时间' }]"
            required
            @click="openStartTime(0)"
            label="活动开始时间"
          />
          <ant-field
            v-model="form.activityEndTimeShow"
            readonly
            :rules="[{ required: true, message: '请填写结束时间' }]"
            required
            @click="openStartTime(1)"
            label="活动结束时间"
          />
          <my-editor v-model="form.activityContent" />
          <div style="margin: 35px">
            <ant-button round block type="danger" native-type="submit">
              提交
            </ant-button>
          </div>
        </ant-form>
        <datetime-picker
          v-show="showDate"
          v-model="currentDate"
          type="datetime"
          title="选择完整时间"
          :min-date="minDate"
          :max-date="maxDate"
          :visible-item-count="10"
          @confirm="confirm"
          @cancel="cancel"
        />
        <picker
          title="请选择活动类型"
          v-show="showType"
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </div>
    </popup>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  NavBar,
  Divider,
  Button,
  Form,
  Field,
  DatetimePicker,
  Popup,
  Toast,
  Collapse,
  CollapseItem,
  Col,
  Row,
  Pagination,
  Dialog,
  Icon,
  SwipeCell,
  Empty,
  Picker,
  Grid,
  GridItem,
} from "vant";
import service from "../../api/service";
import moment from "moment";

import MyEditor from "../../common/myEditor";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  [{ align: [] }],
  ["image"],
];

//发布活动
export default {
  name: "launchEvent",
  components: {
    MyEditor,
    Cell,
    CellGroup,
    NavBar,
    Divider,
    AntButton: Button,
    AntForm: Form,
    AntField: Field,
    DatetimePicker,
    Popup,
    Collapse,
    CollapseItem,
    AntCol: Col,
    AntRow: Row,
    Pagination,
    Dialog,
    Icon,
    SwipeCell,
    Empty,
    Picker,
    Grid,
    GridItem,
  },
  data() {
    return {
      //审批
      submitApprovalShow: false,
      baseURLB: service.baseURLB,
      loading: false,
      columns: [
        "集团运动类",
        "集团文艺类",
        "集团公益类",
        "集团竞技类",
        "集团其他类",
      ],
      list: [],
      page: 1,
      total: 0,
	  approvalpersons:[],
	  approvalpersonsname:"",
      activeNames: [],
      show: false,
      row: {},
      select: 0,
      form: {
        activityName: "",
        numberPeople: 50,
        budget: 0,
        activityStartTimeShow: "",
        activityStartTime: "",
        activityEndTimeShow: "",
        activityEndTime: "",
        activityFinishTimeShow: "",
        activityFinishTime: "",
        activityContent: "",
        motionGroup: "",
      },
      distinguish: "1",
      showDate: false,
      showType: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(),
      tiLength: 0,
      editorOption: {
        placeholder: "请输入内容",
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  document.querySelector("#contents2").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    //设置活动类型
    setMotionGroup() {
      this.showType = true;
    },
    onConfirm(value, index) {
      this.showType = false;
      this.form.motionGroup = value;
    },
    onCancel() {
      this.showType = false;
    },
    init() {
		let _deptId = sessionStorage.getItem("deptId");
		let _jtdeptId = "";
		if(_deptId.indexOf(",") > 0){
			_jtdeptId = _deptId.substring(0,(_deptId.indexOf(",")));
		}else{
			_jtdeptId = _deptId;
		}
		service
		  .get("/system/app-user/queryApproverUserByDeptId", {
		    deptId: _jtdeptId,
			modCode:"activityApprovala"
		  })
		  .then((res) => {
		    if (res.status === 200) {
		      // let arr = [];
		      // res.data.forEach((v) => {
		      //   arr.push(v.userName);
		      // });
			  this.approvalpersons = res.data.filter(function (s) {
			      return s.id != sessionStorage.getItem("id"); 
			  });
			  this.approvalpersonsname=this.approvalpersons.map(item=>{
			      return item.userName;
			    }).join(",");
		    }
		  });
      service
        .get("/api/activity-creation-approval", {
          phone: sessionStorage.getItem("phone"),
          distinguish: this.distinguish,
          competence: sessionStorage.getItem("permission"),
          page: this.page,
        })
        .then((res) => {
          if (res.status === 200) {
            this.list = res.data;
            this.total = res.total;
          }
        });
    },
    //返回
    onClickLeft() {
      this.$router.push({ path: "/personalCenter" });
    },
    //提交
    onSubmit() {
      let form = { ...this.form };
      form.createBy = sessionStorage.getItem("phone");
      form.deptBunch = sessionStorage.getItem("deptId");
      form.initiatorId = sessionStorage.getItem("id");
      form.distinguish = this.distinguish;
      if (form.id) {
        service.put("/api/activity-creation-approval", form).then((res) => {
          if (res.status === 200) {
            Toast.success(res.message);
            this.show = false;
            this.init();
          } else {
            Toast.fail(res.message);
          }
        });
      } else {
        service.post("/api/activity-creation-approval", form).then((res) => {
          if (res.status === 200) {
            Toast.success(res.message);
            this.show = false;
            this.init();
          } else {
            Toast.fail(res.message);
          }
        });
      }
    },
    //报审
    forExamination(row, b) {
      if (b) {
        Toast.success("已经提交");
        return;
      }
      this.row = row;
      Dialog.confirm({
        title: "确定报审",
        message: "提交活动审核,此条审核将会推送给\r\n"+this.approvalpersonsname,
      }).then((v) => {
        this.submitApprovalShow = true;
		let _deptId = sessionStorage.getItem("deptId");
		let _jtdeptId = "";
		if(_deptId.indexOf(",") > 0){
			_jtdeptId = _deptId.substring(0,(_deptId.indexOf(",")));
		}else{
			_jtdeptId = _deptId;
		}
        let form = {
          modCode: "activityApprovala",
          proId: this.row.id,
          userId: sessionStorage.getItem("id"),
          deptId: _jtdeptId,
        };
        this.loading = true;
        service
          .get(
            "/api/activity-creation-approval/groupActivitiesSubmittedForApproval",
            form
          )
          .then((res) => {
            if (res.status === 200) {
              this.loading = false;
              Toast.success(res.message);
              this.init();
            } else {
              this.loading = false;
              Toast.fail(res.message);
            }
          });
      });
    },
    //删除
    del(row) {
      this.row = row;
      Dialog.confirm({
        title: "确定删除",
        message: "删除活动信息",
      }).then((v) => {
        service
          .get("/api/activity-creation-approval/del", { id: this.row.id })
          .then((res) => {
            if (res.status === 200) {
              Toast.success(res.message);
              this.init();
            } else {
              Toast.fail(res.message);
            }
          });
      });
    },
    //修改
    modify(row) {
      this.show = true;
      this.form = { ...row };
      this.form.activityStartTimeShow = moment(row.activityStartTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.form.activityEndTimeShow = moment(row.activityEndTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.form.activityFinishTimeShow = moment(row.activityFinishTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    //选择时间
    confirm(v) {
      this.showDate = false;
      let t = moment(v).format("YYYY-MM-DD HH:mm:ss");
      if (this.select === 0) {
        this.form.activityStartTimeShow = t;
        this.form.activityStartTime = v;
      } else if (this.select === 1) {
        this.form.activityEndTimeShow = t;
        this.form.activityEndTime = v;
      } else {
        this.form.activityFinishTimeShow = t;
        this.form.activityFinishTime = v;
      }
    },
    openStartTime(select) {
      this.select = select;
      this.showDate = true;
    },
    cancel() {
      this.showDate = false;
    },
    //add
    add() {
      this.show = true;
    },
    closeMod() {
      this.showDate = false;
      this.form = {
        activityName: "",
        numberPeople: 50,
        budget: 0,
        activityStartTimeShow: "",
        activityStartTime: "",
        activityEndTimeShow: "",
        activityEndTime: "",
        activityFinishTimeShow: "",
        activityFinishTime: "",
        activityContent: "",
      };
    },
    //跳转
    updateImg(v) {
      this.$router.push({ path: "/updateImg", query: { id: v.id } });
    },
    //活动报名人员
    applicants(v) {
      this.$router.push({
        path: "/applicants",
        query: { id: v.id, url: "/launchEvent" },
      });
    },
    //分享
    copy() {
      Toast.success("链接复制成功");
    },
    //经费申请
    fundApplication(row, b) {
      if (b) {
        // Toast.success("您设置的预算金额为0无法发起经费报销");
        return;
      }
      this.$router.push({
        path: "/fundApplication",
        query: { id: row.id, activityName: row.activityName,distinguish:this.distinguish },
      });
    },
    editorUploadSuccess(e) {
      // 富文本编辑器中图片上传成功回调
      let formData = new FormData();
      let file = e.target.files[0];
      formData.append("file", file);
      formData.append("userName", "userName");
      this.loading = true;
      service.post("/file-up/resources/import", formData).then((res) => {
        this.loading = false;
        if (res.status === 200) {
          let url = service.baseURLB + res.data.fileUrl;
          let quill = this.$refs.myQuillEditor.quill;
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片 res.url为服务器返回的图片地址
          quill.insertEmbed(length, "image", url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        }
      });
    },
    onEditor(e) {
      e.quill.deleteText(this.maxLength, 4);
      if (this.value === "") {
        this.tiLength = 0;
      } else {
        this.tiLength = e.quill.getLength() - 1;
      }
    },
    //分享链接
    shareLink(v) {
      window.location.href = service.baseURLB + "/jtgzh/index/" + v.id;
    },
    //重新发起
    reinitiate(v) {
      this.show = true;
      let arr = v.activityName.split("-");
      let d = moment().format("YYYY年MM月DD日");
      this.form.activityName = d + "-" + arr.pop();
      this.form.numberPeople = v.numberPeople;
      this.form.budget = v.budget;
      this.form.activityContent = v.activityContent;
      this.form.motionGroup = v.motionGroup;
    },
  },
  filters: {
    pstatus(v) {
      switch (v) {
        case "0":
          return "未提交";
        case "1":
          return "审批中";
        case "2":
          return "通过";
        case "3":
          return "未通过";
      }
    },
    pbstatus(v) {
      switch (v) {
        case "0":
          return "未提交";
        case "1":
          return "审批中";
        case "2":
          return "通过";
        case "3":
          return "未通过";
      }
    },
    ptime(v) {
      return v ? moment(v).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
  },
};
</script>

<style scoped lang="less">
.my-back {
  height: 56px;
  position: fixed;
  top: 0;
  background-image: url("../../assets/header_bg.png");
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 99999999;
}

.my-logo {
  height: 1.5rem;
  margin-left: 1.5rem;
}

.my-btn {
  color: #ee0a24;
}

.my {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.btn {
  margin: 1rem 0.5rem;
}
</style>